module.exports = function getResource(label, vars = []) {
    let resources = {
        eyeColor: 'Eye color',
        selectOne: 'select one'
    };

    return resources[label];
};
